import axios from "axios";

export default function OfferitemFormService(offerId, formData, method) {
  let itemId
  let url
  if(formData && formData.id) {
    itemId = formData.id
    url = process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/item/" + itemId
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/items"
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
